import { Route, Switch } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import BlockScreenLoading from "src/features/Loading/ScreenBlock"
import BundleList from "src/pages/Bundle/List"
import Callback from "src/features/Oauth/Callback"
import CreateOrder from "src/pages/CreateOrder"
import Layout from "src/features/Layout"
import Medicine from "src/pages/Medicine/List"
import MedicineDetail from "src/pages/Medicine/Detail"
import Member from "src/pages/Member"
import moment from "moment-timezone"
import Notification from "src/features/Notification"
import PaymentDetail from "src/pages/Payment/Detail"
import PaymentList from "src/pages/Payment/List"
import React, { useEffect } from "react"
import SessionExpiredDialog from "src/features/Authentication/SessionExpiredDialog"
import Supply from "src/pages/Supply/List"
import SupplyDetail from "src/pages/Supply/Detail"
import BundleCreate from "src/pages/Bundle/Create"
import BundleEdit from "src/pages/Bundle/Edit"

import { initSession } from "src/features/Oauth/oauth.ducks"

//set time zone
moment.tz("Asia/Bangkok").locale("th")

const NotFound = () => {
  return <Layout>not found ......</Layout>
}

function App() {
  // *********************************
  // redux state
  // *********************************
  const dispatch = useDispatch()
  const initial = useSelector((state) => state.oauth.initial)
  useEffect(() => {
    dispatch(initSession())
  }, [dispatch])
  // ถ้ายังไม่ initial session ไม่แสดง main app.
  if (!initial) {
    return <div>Loading ...</div>
  }
  // ส่ง view อื่นกลับไป เพื่อไปทำตาม step ต่อไป
  return (
    <div className="App">
      <BlockScreenLoading />
      <Notification />
      <SessionExpiredDialog />
      <Switch>
        <Route exact path="/bundle" component={BundleList} />
        <Route exact path="/bundle/create" component={BundleCreate} />
        <Route exact path="/bundle/:id" component={BundleEdit} />
        <Route exact path="/callback" component={Callback} />
        <Route exact path="/create-order" component={CreateOrder} />
        <Route exact path="/medicine" component={Medicine} />
        <Route exact path="/medicine/:id" component={MedicineDetail} />
        <Route exact path="/member" component={Member} />
        <Route exact path="/payment" component={PaymentList} />
        <Route exact path="/payment/:id" component={PaymentDetail} />
        <Route exact path="/supply" component={Supply} />
        <Route exact path="/supply/:id" component={SupplyDetail} />
        <Route component={NotFound} />
      </Switch>
    </div>
  )
}

export default App
